import type { UI } from '@/v2/types';

import { createCtx } from '@/v2/utils/createCtx';

export const [useCampaign, CampaignProvider] = createCtx<UI.Campaign | null>();
